const minxin = {
  data() {
    return {
      options2: {
        word:"单词/词组",
        sentence:"句子/短文",
        QA:"题目",
        createRole:"创建角色",
        theme:"新建主题",
      },
    };
  },
  computed: {},
  mounted() {},
  activated() {},
  methods: {
    depthCopy(s) {
      return s ? JSON.parse(JSON.stringify(s)) : '';
    }
  }
};

export default minxin;



// WEBPACK FOOTER //
// ./src/components/pages/EnglishVoice/minxins/minxin.js